import { storages } from '@/lib/browserStorage'
import { NewHotelExperienceTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

type NewHotelExperienceState = ApplicationState['newhotelExperienceUI']

const getInitialNewHotelExperienceState = (): NewHotelExperienceState => {
	const stored = storages.session.getItem('newHotelUIEnabled')
	return {
		isNewHotelUIEnabled: stored ? JSON.parse(stored) : false,
	}
}

const initialState: NewHotelExperienceState = getInitialNewHotelExperienceState()

export interface SetNewHotelUIEnabledAction {
	type: typeof NewHotelExperienceTypes.SetNewHotelUIEnabled
	payload: boolean
}

type NewHotelExperienceActions = SetNewHotelUIEnabledAction

export default function NewHotelExperienceReducer(
	state: NewHotelExperienceState = initialState,
	action: NewHotelExperienceActions,
): NewHotelExperienceState {
	if (action.type === NewHotelExperienceTypes.SetNewHotelUIEnabled) {
		storages.session.setItem('newHotelUIEnabled', JSON.stringify(action.payload))
		return { ...state, isNewHotelUIEnabled: action.payload }
	}

	return state
}
